export default __webpack_public_path__ + "static/media/logo.927edc1f.png";